import React from "react";
import "../../../styles/ExpressionBuilder.css";
import PreviewPanel from "../../PreviewPanel/PreviewPanel";
import ExpressionBuilderSection from "../ExpressionBuilderSection/ExpressionBuilderSection";

/**
 * Component for rendering expression builder modal body
 * @param {Object} expression - Current expression object
 * @param {Function} updateRootExpression - Function to update root expression
 * @param {Array} availableFields - Available workflow variables
 * @param {Object} testData - Test data for evaluation
 * @param {boolean} evaluationResult - Evaluation result
 * @param {Function} onTestExpression - Handler for testing expression
 * @param {Object} fieldValidators - Validation functions for fields
 * @returns {JSX.Element} Modal body component
 * @author Abhishek Dhillon
 * @parent ExpressionBuilderModal
 */
const ModalBody = ({ expression, updateRootExpression, availableFields, testData, evaluationResult, onTestExpression, fieldValidators = {} }) => {
  return (
    <div className='expression-builder-modal-body'>
      <div className='row expression-builder-row expression-builder-mobile'>
        {/* Expression Builder Section */}
        <ExpressionBuilderSection
          expression={expression}
          updateRootExpression={updateRootExpression}
          availableFields={availableFields}
          fieldValidators={fieldValidators}
        />

        {/* Preview Panel Section
        <PreviewPanel
          availableFields={availableFields}
          expression={expression}
          testData={testData}
          evaluationResult={evaluationResult}
          onTestExpression={onTestExpression}
        /> */}
      </div>
    </div>
  );
};

export default ModalBody;
